export type EmptyDate = "";

export const EmptyDateRange: DateRange = {
  endDate: "",
  startDate: "",
};

export class DateRange {
  public startDate: Date | EmptyDate = "";
  public endDate: Date | EmptyDate = "";
}
